module.exports = __webpack_public_path__ + "static/media/t6.53a1bd78.jpg";